import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetProducts } from '../../../../../utils/api/products/useGetProducts';
import ProductList from '../../../products/list/ProductTable';

const CategoryProducts = ({ category }) => {
  const { t } = useTranslation('products');
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const { products, count, isLoading } = useGetProducts(
    {
      category: category?.id,
      offset: (currentPage - 1) * pageSize,
      limit: pageSize,
      search: search || undefined,
    },
    {
      enabled: !!category?.id, // Only fetch when category id exists
    }
  );

  return (
    <div style={{ width: '100%', height: '100%', padding: '8px 0' }}>
      <Input
        size="small"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        placeholder={t('filters.search_placeholder')}
        style={{ width: 400, marginBottom: '8px' }}
        allowClear
      />
      <ProductList
        hasSelection={false}
        hasActions={false}
        stickyHeader={false}
        selectedProducts={selectedProducts}
        setSelectedProducts={setSelectedProducts}
        products={products}
        count={count}
        isLoading={isLoading}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
        listHeight={550}
      />
    </div>
  );
};

export default CategoryProducts;
